<template lang="pug">
  .container.grid-lg
    .card.mt-2
      .card-header
        .text-bold Filtrar
      .card-body
        form-filter(@submit="fetchReport")
    .full-height.loading.loading-lg(v-if="loading")
    div(v-if="report && report.data")
      div(v-if="Object.values(report.data).length")
        .card.my-2.page-break
          .card-header
            .h5 Total geral
          .card-body.text-small
            table.table
              thead
                tr
                  th Modelos
                  th.text-right Quantidade
                  th.text-right Valor Total (R$)
              tbody
                tr(v-for="coluna, index in report.colunas")
                  td.text-small {{ coluna }}
                  td.text-right {{ totais[index].quantidade }}
                  td.text-right {{ totais[index].valor_total | currency }}
                tr
                  td.text-bold Sub Total
                  td.text-bold.text-right(v-for='v, k in somarTotal(totais)')
                    span(v-if="'valor_total' === k") {{ v | currency }}
                    span(v-else) {{ v }}
        .card.my-2.page-break(v-for="item, key in report.data")
          .card-header
            .abbr Situação
            .h5 {{ key }}
          .card-body.text-small
            table.table
              thead
                tr
                  th Modelos
                  th.text-right Quantidade
                  th.text-right Valor Total (R$)
              tbody
                tr(v-for="coluna in report.colunas")
                  td.text-small {{ coluna }}
                  td.text-right {{ item[coluna].quantidade || 0 }}
                  td.text-right {{ (item[coluna].valor_total || 0) | currency }}
                tr
                  td.text-bold Sub Total
                  td.text-bold.text-right(v-for='v, k in somarTotal(item)')
                    span(v-if="'valor_total' === k") {{ v | currency }}
                    span(v-else) {{ v }}
      .card.mt-2(v-else)
        .card-body
          .empty
            .empty-icon
              i.fa.fa-search.fa-4x
            p.empty-title.h5 Nada encontrado
            p.empty-subtitle Não foram encontradas Notificações neste período
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import docs from '@/api/indicadores/docs'
import FormFilter from './components/Filter'
import { deepKey } from 'paliari-js-utils'

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    totais() {
      if (!deepKey(this.report, 'data') || !deepKey(this.report, 'colunas')) {
        return []
      }
      const soma = {}
      Object.values(this.report.colunas).forEach(
        coluna => (soma[coluna] = { quantidade: 0, valor_total: 0 }),
      )
      Object.values(this.report.data).forEach(data => {
        Object.keys(data).forEach(coluna => ({
          quantidade: (soma[coluna].quantidade += data[coluna].quantidade),
          valor_total: (soma[coluna].valor_total += data[coluna].valor_total),
        }))
      })

      return Object.values(soma)
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await docs.porModelosSituacao({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
    somarTotal(item) {
      return Object.values(item || {}).reduce(
        (acc, item) => ({
          quantidade: acc.quantidade + item.quantidade,
          valor_total: acc.valor_total + item.valor_total,
        }),
        {
          quantidade: 0,
          valor_total: 0,
        },
      )
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>

<style lang="stylus" scoped>
.table.table-scroll
  font-size 0.6rem
  white-space normal
tr td
  border-left 1px solid #dadee4
  &:last-child
    border-right 1px solid #dadee4
  &:nth-child(3)
    white-space nowrap
</style>
